var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
function getRandom(list) {
    var i = Math.floor(Math.random() * list.length);
    return list[i];
}
function useDocumentHidden() {
    var _a = __read(React.useState(document.visibilityState === "hidden"), 2), hidden = _a[0], setHidden = _a[1];
    React.useEffect(function () {
        var update = function () {
            setHidden(document.visibilityState === "hidden");
        };
        document.addEventListener("visibilitychange", update);
        return function () { return document.removeEventListener("visibilitychange", update); };
    });
    return hidden;
}
export function Music(_a) {
    var nullableUrls = _a.urls;
    var audioElement = React.useRef(null);
    var urls = nullableUrls.filter(function (x) { return x; });
    var _b = __read(React.useState(getRandom(urls)), 2), url = _b[0], setUrl = _b[1];
    var isHidden = useDocumentHidden();
    React.useEffect(function () {
        if (isHidden) {
            if (audioElement.current) {
                void audioElement.current.pause();
            }
            return;
        }
        var play = function () {
            if (!audioElement.current) {
                return;
            }
            audioElement.current.volume = 0.8;
            void audioElement.current.play();
        };
        document.addEventListener("click", play);
        document.addEventListener("touchstart", play);
        play();
        return function () {
            document.removeEventListener("click", play);
            document.removeEventListener("touchstart", play);
        };
    }, [url, isHidden]);
    if (!url) {
        return null;
    }
    return (React.createElement("audio", { autoPlay: !isHidden, controls: false, onEnded: function () {
            setUrl(getRandom(urls));
        }, src: url, ref: audioElement }));
}
//# sourceMappingURL=data:application/json;base64,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